import LayoutWrapper from "~/components/layouts/layoutWrapper";
import Product from "~/components/pages/product";
import Section from "~/components/pages/section";
import Sections from "~/components/pages/sections";
import Redis from "~/lib/redis";
import {
  detectPageType,
  filterIndexLogic,
  filterLogic,
  PageTypes,
  productLogic,
  sectionLogic,
  sectionsLogic,
} from "~/pagesSrrLogic/catalog";
import { getCatalogSortFromRequest } from "~/pagesSrrLogic/catalog/section/catalogSortCookie";
import {
  baltexLogic,
  landingLogic,
} from "~/pagesSrrLogic/catalog/section/filterLogic";
import pagesWrapper from "~/pagesSrrLogic/pagesWrapper";
import { wrapper } from "~/redux";
import { getBaltexSections } from "~/redux/action-creaters/baltex";
import { addBreadcrumb } from "~/redux/action-creaters/breadcrumbs";
import { checkIsBaltex } from "~/utils";
import { assignCartNoInstallTest } from "~/utils/abTests";
import { sspWrapper } from "~/utils/errors/sspWrapper";
import { getHost } from "~/utils/locationServer";
import { redirects } from "~/utils/redirects";

export default function CatalogPage({
  pageType,
  section,
  scripts,
  isIndex,
  host,
}: any) {
  return (
    <LayoutWrapper scripts={scripts} isIndex={isIndex} host={host}>
      {pageType === PageTypes.sections && <Sections section={section} />}
      {(pageType === PageTypes.section || pageType === PageTypes.filter) && (
        <Section section={section} />
      )}
      {pageType === PageTypes.product && <Product />}
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ resolvedUrl, params, query, req, res }: any) => {
    const isReset = Boolean(query.reset);
    const host = getHost(req);

    store.dispatch(addBreadcrumb({ link: "/catalog/", name: "Каталог" }));
    const PageData: any = await detectPageType(
      store,
      params.code,
      isReset,
      Redis,
    );
    let isIndex = true;

    // Старый формат пагинации Bitrix. Номер страницы переносится в ?page=,
    // раньше он терялся и ссылка со второй страницы вела на первую (ТЗ п. 6.4).
    if (/[?&]PAGEN_\d+=/.test(resolvedUrl)) {
      const basePath = resolvedUrl.split("?")[0];
      const base = basePath.endsWith("/") ? basePath : `${basePath}/`;
      const pageNumber = Number(resolvedUrl.match(/[?&]PAGEN_\d+=(\d+)/)?.[1]);

      return {
        redirect: {
          destination: pageNumber > 1 ? `${base}?page=${pageNumber}` : base,
          statusCode: 301,
        },
      };
    }

    const baltexResult = await baltexLogic(PageData, store, host);
    if (baltexResult) {
      return baltexResult;
    }

    await landingLogic(PageData, store, host);

    if (PageData.pageType === PageTypes.filter) {
      const filterResult = await filterLogic(
        PageData,
        Redis,
        store,
        host,
        resolvedUrl,
        isReset,
      );
      if (filterResult) {
        return filterResult;
      }
      isIndex = filterIndexLogic(PageData, host.includes("baltex"));
    }

    let result = null;
    if (
      PageData.pageType === PageTypes.filter ||
      PageData.pageType === PageTypes.section
    ) {
      result = await sectionLogic(
        PageData,
        Redis,
        store,
        host,
        resolvedUrl,
        query,
        isReset,
        getCatalogSortFromRequest(req, res, query),
      );
    } else if (PageData.pageType === PageTypes.product) {
      result = await productLogic(PageData, Redis, store, host, isReset);

      // @ts-ignore
      const redirect = redirects[PageData.productCode];
      if (result && redirect) {
        return {
          redirect: {
            destination:
              `${resolvedUrl.replace(PageData.productCode, redirect)}/`.replace(
                "//",
                "/",
              ),
            statusCode: 301,
          },
        };
      }

      if (!result) {
        assignCartNoInstallTest(store, req, res, host);
      }
    } else if (PageData.pageType === PageTypes.sections) {
      await sectionsLogic(PageData, store);
    } else if (PageData.pageType === PageTypes.notFound) {
      result = {
        notFound: true,
      };
    }
    if (result) {
      return result;
    }
    if (checkIsBaltex(host)) {
      await store.dispatch(getBaltexSections(isReset));
    }

    return pagesWrapper(
      {
        ...PageData,
        isIndex,
      },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/catalog/",
      false,
    );
  }),
);
